import React from "react";

import { SportsProvider } from "../_context/SportsContext";
import { SportsBetCartProvider } from "../_context/SportsBetCartContext";

const SportsbookRuntimeProviders = ({ children }) => (
  <SportsProvider>
    <SportsBetCartProvider>{children}</SportsBetCartProvider>
  </SportsProvider>
);

export default SportsbookRuntimeProviders;
